import { copyToClipboard } from '@/utils/extras'
import { urlFromAddress } from '@/utils/shortenAddress'
import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { GoLinkExternal } from 'react-icons/go'

const Url = (
    caption: string,
    address: string,
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>,
    showTooltip: boolean,
) => (
    <span>
        <span>
            <Image
                src="/hexagon-copy.svg"
                alt="arrow"
                width={15}
                height={15}
                style={{
                    marginLeft: '1px',
                    cursor: 'pointer',
                }}
                onClick={() => copyToClipboard(address, setShowTooltip)}
            />
            &nbsp;
            <Link href={urlFromAddress(address)}>
                {!showTooltip && <span className="gray">{caption} </span>}
                {showTooltip && (
                    <span
                        className="gray"
                        style={{
                            visibility: showTooltip ? 'visible' : 'hidden',
                            opacity: showTooltip ? 1 : 0,
                            transition: 'opacity 0.5s ease-in-out',
                        }}
                    >
                        Copied!
                    </span>
                )}
            </Link>
            <Link
                href={urlFromAddress(address)}
                className={'z-index-hundred'}
                target="_blank"
                rel="noopener noreferrer"
                passHref={true}
            >
                <GoLinkExternal className="social-media-icon margin-top-five gray " />
            </Link>
        </span>
    </span>
)
export default Url
